import { render, staticRenderFns } from "./IconAccept.vue?vue&type=template&id=e4067fa2&scoped=true&"
import script from "./IconAccept.vue?vue&type=script&lang=js&"
export * from "./IconAccept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4067fa2",
  null
  
)

export default component.exports